export default __webpack_public_path__ + "static/media/avtar15.83eb9dec.jpg";